<!-- ***Designed by Salman Rifai***** -->
<!-- ***CP-214*** -->

<!-- Hello Generic field -->
<div class="dhl-field-autocomplete-v2" [formGroup]="frmGroup">
    <div class="form-field-wrapper" [ngClass]="{'typing':typing ,'disabled': frmGroup.get(this.configData.name)['disabled'] }">
        <div class="form-field-control" #formControl
            [ngClass]="{'error': (frmGroup.get(configData.name).errors && frmGroup.get(configData.name).touched && !frmGroup.get(configData.name).valid)}">
            <input appFormFieldAutocompleteV2 #inputEle type="{{fieldType}}" class="base-field" autocomplete="off"
                [attr.data-placeholder]="placeholder | translate" [required]="configData.required"
                [formControlName]="$safeNavigationMigration(configData?.name)" [formControl]="frmGroup.get(configData.name)"
                 (keyup)="onkeyupHandler($event)" (click)="setOnFocus($event)"
                (change)="controlValueChange($event)" />
            <span class="form-field-label">
                <label class="base-label">
                    {{$safeNavigationMigration(configData?.label) | translate}}
                    <span *ngIf="configData?.required && !frmGroup?.get($safeNavigationMigration(configData?.name))?.isRequired"> *</span>
                </label>
            </span>
            <span *ngIf="fieldIcon" class="field-icon" (click)="popFieldAction($event)">
                <span class="default-icon">
                    <img src="../../../../../assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,662,20,20))"
                        style="width:20px;height:20px" type="image/svg+xml" />
                </span>
                <span class="active-icon">
                    <img src="../../../../../assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,692,20,20))"
                        style="width:20px;height:20px" type="image/svg+xml" />
                </span>
            </span>
        </div>
        <!-- <div class="cancel" *ngIf="typing"><img
                src="../../../../../../assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,30,24,24))" (click)="close()" />
        </div> -->
        
        <div class="form-field-hint" *ngIf="frmGroup['secondaryText']">
            <!-- <span class="hint">Optional hint text</span> -->
            <span *ngIf="configData['secondaryText'];">
                <span>
                    
                    {{frmGroup['secondaryText'].source}}
                </span>
                <span>
                    -
                </span>
                <span>
                    {{frmGroup['secondaryText'].destination}}
                </span>
            </span>  
        </div>
        <ng-template #noSecondaryText>
            <div *ngIf="frmGroup['secondaryText']" class="form-field-hint" style="padding: 15px 0;">
                <span *ngIf="frmGroup['hazmatIcon']" color="accent" matTooltip="Dangerous Good">
                    <fa-icon [icon]="['fas', 'biohazard']"></fa-icon>
                </span>
                <span *ngIf="frmGroup['tempControlIcon']" color="accent" matTooltip="Temperature Control">
                    <fa-icon [icon]="['fas', 'temperature-low']"></fa-icon>
                </span>
                <span [innerHTML]="frmGroup['secondaryText']"></span>
            </div>

        </ng-template>
        <div class="form-field-error"
            [ngClass]="{'hide-error': !(frmGroup.get(configData.name).errors && (frmGroup.get(configData.name).touched ||frmGroup.get(configData.name).value) && !frmGroup.get(configData.name).valid)}">
            <span class="error-icon">
                <img class="dhl-input-error-icon"
                    src="/assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,60,24,24))">
            </span>
            <span class="error-text" *ngIf="frmGroup.get(configData.name).errors">
                <span *ngIf="frmGroup.get(configData.name).errors.required">{{enum.Required_Validation | translate}}</span>
                <span *ngIf="configData?.groupValidation?.columnGroup && frmGroup.get(configData.name)?.errors?.required"> if {{configData?.groupValidation?.columnGroupMsg}} are empty</span>
                <span *ngIf="frmGroup.get(configData.name).errors.NoItemFound">{{enum.NoRecordFound_Validation | translate}}</span>
                <span *ngIf="frmGroup.get(configData.name).errors.selectFromList">{{enum.SelectFromList_Validation | translate}}</span>
                <span *ngIf="configData?.groupValidation?.columnGroup && frmGroup.get(configData.name)?.errors?.required"> if {{configData?.groupValidation?.columnGroupMsg}} are empty</span>
            </span>
        </div>
        <div *ngIf="progressBar" class="search-result spinner">
            <app-progress-spinner-v2 ></app-progress-spinner-v2>
        </div>
        <div *ngIf="!progressBar && !suggestionList.length && addNewItem" class="search-result">
            <div class="suggestion-list">
                <div (click)="AddNewItem($event)">
                    <a class="list-items" >
                        <span class="suggestion-item" style="display: inline;flex-direction: column;">
                            <span>
                                Add New Item
                            </span>
                        </span>
                    </a>
                </div>
               
            </div>
        </div>
        <div *ngIf="typing && (suggestionList)?.length > 0" class="search-result">
            <!-- <div *ngIf="(suggestionList)?.length > 0" class="search-history-wrapper">
                <label class="search-history-label">Search History</label>
            </div> -->
            <div class="suggestion-list" [ngClass]="{'disabled':suggestion.disable}"
                *ngFor="let suggestion of suggestionList ">
                <a class="list-items" (click)="selectItem($event,suggestion, suggestion.disable)">
                    <!-- <img class="search_icon"
                        src="/assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,630,24,24))" /> -->
                    <div fxFlex="0 0 40px">
                        <mat-icon color="accent">ballot</mat-icon>
                    </div>
                    <ng-container *ngIf="configData['primaryText'];">
                        <span class="primary-label" style="display: inline-flex;flex-direction: column;">
                            <span>
                                {{suggestion[configData['primaryText'][0]]}} -
                                {{suggestion[configData['primaryText'][1]]}}
                            </span>
                            <span class="secondary-label" v>
                                <fa-icon *ngIf="suggestion.hazmat" [icon]="['fas', 'biohazard']"></fa-icon>
                                <fa-icon *ngIf="suggestion.tempControl" [icon]="['fas', 'temperature-low']"></fa-icon>
                                <span *ngIf="suggestion.nmfcarticle !== '' ">
                                    Article: {{suggestion.nmfcarticle}}
                                </span>
                                <span *ngIf="suggestion.nmfcclass !== '' ">
                                    <span *ngIf="suggestion.nmfcarticle !== '' ">,</span>
                                    Class: {{suggestion.nmfcclass}}
                                </span>
                            </span>
                        </span>
                    </ng-container>
                </a>
            </div>
        </div>
    </div>
</div>